import React from "react";
import "./_terms.scss";

const TermsAndConditionsGeneral = () => {
  return (
    <div className="w-100 dashboard-childrens">
      <div className="w-100">
        <div className="d-flex">
          <div className="terms w-100">
            <div className="main">
              <div className="text-center mt-5 mb-3">
                <h1>Terms and Conditions for NexGen Inspector Assistant</h1>
                <p className="opacity-50 mt-2">
                Effective Date: November 26, 2024
                </p>
              </div>
              <div className="termsandconditions">
              
      <p>Welcome to <strong>NexGen Inspector Assistant.</strong> These Terms and Conditions ("Terms") govern your access to and use of the  <strong>NexGen Inspector Assistant</strong> app ("the App") and its services. By downloading, accessing, or using the App, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree, please do not use the App.</p>
      {/* line  */}
      <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>

      <h3>1. Acceptance of Terms</h3>
      <p>By using the App, you agree to these Terms and our Privacy Policy. These Terms are legally binding and form an agreement between you ("User") and us ("NexGen Inspector Assistant," "we," "our," or "us").</p>
      {/* line  */}
      <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>

      <h3>2. Use of the App</h3>
      <ul style={{ marginLeft: "20px" }}>
        <li><p><strong>Purpose:</strong> The App is intended to assist home inspectors in generating professional inspection reports through AI technology.</p></li>
        <li><p><strong>License:</strong> We grant you a non-exclusive, non-transferable, revocable license to use the App for its intended purpose.</p></li>
        <li><p><strong>Restrictions:</strong> You may not reverse engineer, decompile, disassemble, reproduce, or distribute any part of the App without our prior written consent.</p></li>
      </ul>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>3. Subscription and Billing</h3>
      <ul style={{ marginLeft: "20px" }}>
        <li><p><strong>Free Trial:</strong> The App offers a 7-day free trial. After this period, you must subscribe to continue using the App.</p></li>
        <li><p><strong>Billing:</strong> Subscription fees will be charged based on the plan you select during registration.</p></li>
        <li><p><strong>Cancellation:</strong> You may cancel your subscription anytime through your account settings. Canceling will stop future charges but will not provide refunds for past charges.</p></li>
      </ul>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>4. Intellectual Property</h3>
      <ul style={{ marginLeft: "20px" }}>
        <li><p><strong>Ownership:</strong> All content, code, design, trademarks, and features of the App are the
        exclusive property of NexGen Inspector Assistant or its licensors.</p></li>
        <li><p><strong>Prohibited Use:</strong> You may not copy, modify, or use any part of the App’s intellectual property for commercial purposes or any unauthorized use.</p></li>
      </ul>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>5. Disclaimer of AI-Generated Content</h3>
      <ul style={{ marginLeft: "20px" }}>
        <li><p><strong>Accuracy Disclaimer:</strong> The App uses AI technology to assist in generating professional inspection reports. However, AI may produce inaccurate, incomplete, or irrelevant information.</p></li>
        <li><p><strong>User Responsibility:</strong> All AI-generated content must be carefully reviewed, edited, and approved by the User before including it in any final report or sharing it with customers</p></li>
        <li><p><strong>No Liability:</strong> NexGen Inspector Assistant is not responsible for errors, omissions, or inaccuracies in AI-generated content or for any damages resulting from its use.</p></li>
      </ul>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>6. Limitations of Liability</h3>
      <ul style={{ marginLeft: "20px" }}>
        <li><p><strong>No Warranty:</strong> The App is provided "as is" and "as available," without warranties of any kind, express or implied. We do not guarantee the accuracy, reliability, or availability of the App.</p></li>
        <li><p><strong>Limited Liability:</strong> We are not liable for any indirect, incidental, consequential, or punitive damages arising from your use of the App, including but not limited to data loss, business interruptions, or legal disputes.</p></li>
        <li><p><strong>User’s Responsibility:</strong> You agree to use the App at your own risk and are solely responsible for verifying the accuracy of all outputs and data before relying on them.</p></li>
      </ul>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>7. User Obligations</h3>
      <ul style={{ marginLeft: "20px" }}>
        <li><p><strong>Compliance:</strong> Users agree to comply with all applicable laws and regulations when using the App.</p></li>
        <li><p><strong>Indemnification:</strong> You agree to indemnify and hold NexGen Inspector Assistant harmless from any claims, losses, liabilities, or expenses (including attorney fees) arising from your use of the App, violation of these Terms, or infringement of third-party rights.</p></li>
      </ul>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>8. Data Privacy</h3>
      <p>Your use of the App is subject to our <strong>Privacy Policy</strong>, which outlines how we collect, store, and use your data. By using the App, you consent to the practices described in the Privacy Policy.</p>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>9. Updates and Changes</h3>
      <p>We may modify these Terms or the App at any time without prior notice. Changes will be effective immediately upon posting. Continued use of the App indicates your acceptance of any changes.</p>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>10. Account Security</h3>
      <ul style={{ marginLeft: "20px" }}>
        <li><p>Users are responsible for maintaining the confidentiality of their login credentials.</p></li>
        <li><p>NexGen Inspector Assistant is not responsible for unauthorized access to your account due to negligence or misuse.</p></li>
      </ul>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>11. Prohibited Conduct</h3>
      <p>You agree not to:</p>
      <ul style={{ marginLeft: "20px" }}>
        <li><p>Use the App for unlawful purposes.</p></li>
        <li><p>Interfere with the App’s operations or attempt to gain unauthorized access.</p></li>
        <li><p>Share or distribute harmful content, such as malware, through the App.</p></li>
      </ul>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>12. Governing Law and Dispute Resolution</h3>
      <p>These Terms are governed by the laws of [Your Jurisdiction]. Any disputes arising under these Terms will be resolved through mediation or arbitration before resorting to litigation.</p>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>13. Termination</h3>
      <p>We reserve the right to suspend or terminate your account without notice if you violate these Terms or engage in prohibited activities.</p>
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <h3>14. Contact Us</h3>
      <p>For any questions or concerns about these Terms, please contact us:</p>
      <ul style={{ marginLeft: "20px" }}>
        <li><p><strong>Website:</strong> <a href="https://www.nexgeninspectorassistant.com" target="_blank" rel="noopener noreferrer">www.nexgeninspectorassistant.com</a></p></li>
        <li><p><strong>Email:</strong> <a href="mailto:support@nexgeninspectorassistant.com">support@nexgeninspectorassistant.com</a></p></li>
      </ul>
      
      
{/* line  */}
<div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
      <p className="mb-4"><strong>By using the NexGen Inspector Assistant app, you acknowledge and agree to these Terms and Conditions.</strong></p>
   
              </div>
             
            </div>

           
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsGeneral;
